import { autoinject, transient, computedFrom, useView } from "aurelia-framework";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../constants/authentication/claims";
import { RightshipEntityAttachmentManager } from "../../../common-steps/rightship-entity-attachment/rightship-entity-attachment-manager";
import { GhgVerificationModel } from "../../../../../../models/ghgs/ghg.models";

@autoinject
@transient()
@useView('views/pages/modules/ghg/steps/ghg-documents/ghg-documents.html')
export class GhgDocuments {
    public multiple: boolean = true;
    public ghgVerification: GhgVerificationModel;
    public rightshipEntityAttachmentManager: RightshipEntityAttachmentManager;
    public accept: string = "application/pdf,image/png,image/jpeg,image/jpg,application/zip,application/x-zip-compressed,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/vnd.ms-outlook,.msg";
    constructor(private userClaimsService: UserClaimsService) {
    }

    @computedFrom("rootItem", "rootItem.isClosed")
    public get statusIsFinal(): boolean {
        return this.ghgVerification && this.ghgVerification.isClosed;
    }

    @computedFrom('rootItem', 'getItemId')
    public get canAdd(): boolean {
        return this.rightshipEntityAttachmentManager.canAdd && (this.ghgVerification.ghgVerificationId && this.ghgVerification.ghgVerificationId > 0) && this.userClaimsService.hasPermission(Claims.CanAddEnvironmentalVerification);
    }

    @computedFrom('rootItem', 'getItemId')
    public get canDelete(): boolean {
        return this.rightshipEntityAttachmentManager.canDelete && (this.ghgVerification.ghgVerificationId && this.ghgVerification.ghgVerificationId > 0) && this.userClaimsService.hasPermission(Claims.CanAddEnvironmentalVerification);
    }

    activate(model: { ghgVerification: GhgVerificationModel, rightshipEntityAttachmentManager: RightshipEntityAttachmentManager }) {
        this.rightshipEntityAttachmentManager = model.rightshipEntityAttachmentManager;
        this.rightshipEntityAttachmentManager.accept = this.accept;
        this.ghgVerification = model.ghgVerification;
    }
}
